// istanbul ignore file
import { Stack, Typography } from '@mui/material';
import PageSad from 'illustrations/PageSad';
import React from 'react';

interface IErrorFallbackProps {
	error?: Error | string;
}

const GlobalErrorFallback: React.FC<IErrorFallbackProps> = ({
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	error = null
}) => (
	<Stack
		direction="column"
		alignItems="center"
		justifyContent="center"
		minHeight="100vh"
		bgcolor="background.default"
	>
		<Stack spacing={3} alignItems="center">
			<PageSad height="30%" />
			<Typography variant="h4" fontWeight={600} color="text.primary">
				Something went wrong
			</Typography>
			<Typography variant="body1" color="text.secondary">
				An unexpected error occurred. Please contact your administrator.
			</Typography>
		</Stack>
	</Stack>
);

export default GlobalErrorFallback;
